import { API_JWT_BASE_URL } from '../http'

export const SEARCH_SECURITY_KEYS_API = `${API_JWT_BASE_URL}/admin/securitykeys/search`
export const UPDATE_SECURITY_KEYS_API = `${API_JWT_BASE_URL}/admin/securitykeys/`
export const CREATE_SECURITY_KEYS_API = `${API_JWT_BASE_URL}/admin/securitykeys`
export const DELETE_SECURITY_KEYS_API = `${API_JWT_BASE_URL}/admin/securitykeys`
export const GET_SECURITY_KEYS_DETAIL_API = `${API_JWT_BASE_URL}/admin/securitykeys/details/`

export const SECURITY_KEY_QUERY_KEYS = {
  SEARCH_SECURITY_KEYS: 'searchSecurityKey',
  UPDATE_SECURITY_KEYS: 'updateSecurityKey',
  CREATE_SECURITY_KEYS: 'createSecurityKey',
  DELETE_SECURITY_KEYS: 'deleteSecurityKey',
  GET_SECURITY_KEYS_DETAIL: 'getSecurityKeyDetail'
}
